import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const JobService = {};

JobService.createJob = function (data) {
  return axiosPrivate({
    method: "post",
    url: `/Jobs/${data.parentId}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

JobService.UpdateJob = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/Jobs/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

JobService.ToggleStatusJob = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/Jobs/toggleJobStatus/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

JobService.getJobs = function (page, limit) {
  return axiosPrivate({
    method: "get",
    url: `/Jobs?limit=${limit}&page=${page}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

JobService.getOneJob = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/Jobs/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

JobService.deleteJob = function (id) {
  return axiosPrivate({
    params: {
      id: id,
    },
    method: "delete",
    url: `/Jobs`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default JobService;
